import { Link } from "react-router-dom";
import "./index.scss";

export const Footer = () => (
  <footer className="footer flex flex-col items-center py-4" id="footer">
    <h1 className="warning text-center">
      
    </h1>
    <ul className="footer_list flex flex-col lg:flex-row justify-between my-4">

      <li className="foot_item text-center">
        <Link to="/credits" className="foot_item_link">
          Credits
        </Link>
      </li>
      <li className="foot_item text-center">
        <a href="">
          <i className="fab fa-github"></i>
        </a>
        <a href="">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="">
          <i className="fas fa-envelope-square"></i>
        </a>
      </li>
    </ul>
  </footer>
);
